/* eslint-disable no-unused-vars */
import { PaymentsContent } from 'components';
import * as S from './PaymentsPage.styled';

export const PaymentsPage = () => {
  if (window.REACT_APP_ENV !== 'qa' && window.REACT_APP_ENV !== 'development') {
    return (
      <h2 style={{ color: 'red', textAlign: 'center', marginTop: '132px' }}>
        This page available only for QA mode
      </h2>
    );
  }

  return (
    <S.Box>
      <S.Title>Payments</S.Title>
      <PaymentsContent />
    </S.Box>
  );
};
